import React, { useContext, useEffect } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Text } from "react_reusable_components";
import { TwoRow } from "../../core/layouts";
import { ProductCategoryContext } from "../../globalContext/productCategory/productCategoryProvider";
import ProductCategoryService from "../../services/product-category-service";
import variables from "../../themes/base/styles/variables";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import HeadingContainer from "../HeadingContainer";
import SubCategoryCardContainer from "../SubCategoryCardContainer";
import Style from "./ViewProductCategoryContainerStyles.module.scss";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import { getProductCategoryById } from "../../globalContext/productCategory/productCategoryActions";

const ViewProductCategoryContainerStyles = {
  mainTwoRowStyle: {
    padding: `${variables.paddingMedium} 0`,
    position: "relative",
    gap: variables.mediumGap,
    overflow: "unset",
    height: "100%",
  },
  topSectionStyle: {
    padding: `0 ${variables.paddingMedium}`,
  },
  textStyle: {
    color: variables.textDefault,
    marginBottom: variables.marginSmall,
    lineHeight: variables.lineHeightSmall,
    fontSize: variables.fontSizeNormal,
    textTransform: "capitalize",
  },
  cardsContainer: {
    marginTop: `${variables.paddingMedium}`,
    padding: `0 ${variables.paddingSmall}`,
    overflowY: "auto",
    display: variables.dFlex,
    justifyContent: "center",
    height: "calc(100% - 5rem)",
  },
  bottomSectionTwoRowStyle: {
    overflow: "unset",
  },
  subCategorySectionStyle: {
    height: "calc(100% - 5rem)",
    overflowY: "hidden",
  },
};

const ViewProductCategoryContainer = () => {
  const [productCategoryState, productCategoryDispatch] = useContext(
    ProductCategoryContext
  );
  const loaderDispatch = useContext(GlobalLoaderContext)[1];
  const { id } = useParams();
  const intl = useIntl();
  useEffect(() => {
    if (id) {
      ProductCategoryService.getProductCategoryById(
        productCategoryDispatch,
        loaderDispatch,
        id,
        intl
      );
    }
    return () => {
      productCategoryDispatch(getProductCategoryById({}));
    };
  }, [id]);

  return (
    <TwoRow
      style={ViewProductCategoryContainerStyles.mainTwoRowStyle}
      topSectionStyle={ViewProductCategoryContainerStyles.topSectionStyle}
      topSection={
        <TwoRow
          topSection={
            <Text style={ViewProductCategoryContainerStyles.textStyle}>
              {getLocalizedMessage(intl, "productCategory.productCategoryName")}
            </Text>
          }
          bottomSection={
            <Text style={ViewProductCategoryContainerStyles.textStyle}>
              {
                productCategoryState?.productCategoryData?.result?.[0]
                  ?.productCategoryName
              }
            </Text>
          }
        />
      }
      bottomSectionStyle={
        ViewProductCategoryContainerStyles.subCategorySectionStyle
      }
      bottomSection={
        <TwoRow
          style={ViewProductCategoryContainerStyles.bottomSectionTwoRowStyle}
          topSectionStyle={ViewProductCategoryContainerStyles.topSectionStyle}
          topSection={
            <HeadingContainer
              heading={getLocalizedMessage(
                intl,
                "productCategory.subProductCategory"
              )}
              headingClassName={Style["productCategoryForm-heading"]}
              description={getLocalizedMessage(
                intl,
                "productCategory.viewSubProductCategory"
              )}
              descriptionClassName={Style["productCategoryForm-description"]}
            />
          }
          bottomSectionStyle={ViewProductCategoryContainerStyles.cardsContainer}
          bottomSection={
            <SubCategoryCardContainer
              subCategory={
                productCategoryState?.productCategoryData?.result?.[0]
                  ?.subCategory
              }
            />
          }
        />
      }
    />
  );
};

export default ViewProductCategoryContainer;
